import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  title,
  domain1Color,
  domain2Color,
  domain3Color,
  domain4Color,
  domain5Color,
  domain6Color,
  domain7Color,
  coloredShadow,
  description,
  cardTitle,
  mlAuto
} from "assets/jss/material-kit-pro-react.jsx";

const domainTitleStyle = {
  coloredShadow,
  cardTitle,
  mlAuto,
  domainTitleStyle: {
    // maxWidth: "120px",
    marginBottom: "0",
    marginTop: "10px",
    padding: "0px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "8px",
      lineHeight: "0"
    }
  },
  justifyContentCenter: {
    WebkitBoxPack: "center !important",
    MsFlexPack: "center !important",
    justifyContent: "center !important"
  },
  stats: {
    color: grayColor[0],
    display: "flex",
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "3px",
      marginRight: "3px",
      marginLeft: "3px",
      fontSize: "18px",
      lineHeight: "18px"
    },
    "& svg": {
      position: "relative",
      top: "3px",
      marginRight: "3px",
      marginLeft: "3px",
      width: "18px",
      height: "18px"
    }
  },
  image: {
    maxWidth: "100px"
  },
  iconWrapper: {
    float: "left",
    marginTop: "24px",
    marginRight: "10px"
  },
  cardCategory: {
    marginTop: "10px",
    "& svg": {
      position: "relative",
      top: "8px"
    }
  },
  cardDescription: {
    ...description,
    fontSize: "0.6em"
  },
  cardDetails: {
    color: grayColor[14]
  },
  D1: {
    color: domain1Color[0]
  },
  D2: {
    color: domain2Color[0]
  },
  D3: {
    color: domain3Color[0]
  },
  D4: {
    color: domain4Color[0]
  },
  D5: {
    color: domain5Color[0]
  },
  D6: {
    color: domain6Color[0]
  },
  D7: {
    color: domain7Color[0]
  },
  warning: {
    color: warningColor
  },
  danger: {
    color: dangerColor
  },
  success: {
    color: successColor
  },
  info: {
    color: infoColor
  },
  rose: {
    color: roseColor
  },
  gray: {
    color: grayColor
  },
  icon: {
    width: "36px",
    height: "36px"
  },
  descriptionWrapper: {
    color: grayColor,
    overflow: "hidden"
  },
  title,
  description: {
    color: grayColor,
    overflow: "hidden",
    marginTop: "0px",
    fontSize: "14px"
  },
  iconWrapperVertical: {
    float: "none"
  },
  iconVertical: {
    width: "61px",
    height: "61px"
  }
};

export default domainTitleStyle;
